import { render, staticRenderFns } from "./AIChatView.vue?vue&type=template&id=5938cddc&scoped=true"
import script from "./AIChatView.vue?vue&type=script&lang=js"
export * from "./AIChatView.vue?vue&type=script&lang=js"
import style0 from "./AIChatView.vue?vue&type=style&index=0&id=5938cddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5938cddc",
  null
  
)

export default component.exports